const styles = {
  p: { margin: 0 },
};

export default styles;
